function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo } from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { getTestIds } from "../../utils/TestIds";
import { TextField } from "../TextField";
import styles from "./AnimatedTextField.module.scss";
import { useAnimatedPlaceholder } from "./hooks/useAnimatedPlaceholder";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetAnimatedTextFieldTID = parentTestId => getTestIds(parentTestId);
export const AnimatedTextField = _ref => {
  let {
    suggestions,
    staticPrefix = '',
    value,
    onChange,
    onBlur,
    disabled = false,
    error,
    helperText,
    collapseHelperText,
    showHelperTextOnFocusOnly,
    inputRef,
    placeholder,
    testId,
    label,
    className,
    multiline,
    minRows,
    maxRows,
    inputRootClass,
    inputProps
  } = _ref;
  const {
    AnimatedTextFieldTID
  } = useMemo(() => GetAnimatedTextFieldTID(testId), [testId]);
  const placeholderState = useAnimatedPlaceholder({
    disabled,
    value,
    suggestions
  });
  const showAnimatedPlaceholder = !disabled && !value && suggestions.length > 0;
  const textFieldProps = {
    value,
    onChange,
    onBlur,
    disabled,
    error,
    helperText,
    collapseHelperText,
    showHelperTextOnFocusOnly,
    inputRef,
    label,
    placeholder: showAnimatedPlaceholder ? '' : placeholder,
    testId: AnimatedTextFieldTID.TextField(),
    multiline,
    minRows,
    maxRows,
    inputRootClass,
    inputProps
  };
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.container, className),
    "data-testid": AnimatedTextFieldTID.Root(),
    children: [/*#__PURE__*/_jsx(TextField, _objectSpread({}, textFieldProps)), showAnimatedPlaceholder && /*#__PURE__*/_jsxs(motion.div, {
      className: cn(styles.animatedPlaceholder, {
        [styles.multiline]: multiline
      }),
      animate: {
        opacity: placeholderState.opacity
      },
      transition: {
        duration: placeholderState.duration
      },
      "data-testid": AnimatedTextFieldTID.AnimatedPlaceholder(),
      children: [staticPrefix, placeholderState.displayedText, placeholderState.isTyping && /*#__PURE__*/_jsx("span", {
        className: styles.cursor,
        children: "|"
      })]
    })]
  });
};